module.exports = __webpack_public_path__ + "static/media/handheldVideo.1ad1dc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handheldVideo.png
// module id = 873
// module chunks = 3